import {Component, OnInit, Output, EventEmitter, Input, ViewChild} from '@angular/core'
import {LocalDeviceDetectorService, RichsnipetService} from 'dmmp-services'
import {MultilevelMenuComponent} from '../multilevel-menu/multilevel-menu.component'

@Component({
  selector: 'dmmp-website-header-v2',
  templateUrl: './website-header-v2.component.html'
})
export class WebsiteHeaderV2Component implements OnInit {

  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  @Output() notSupportedEmitter = new EventEmitter()
  @Output() clearResult = new EventEmitter()
  @Output() search = new EventEmitter()
  @Input() identifier
  @Input() result
  @Input() module
  @Input() principalMenu
  @Input() multilevelMenu
  @Input() universityInfo
  currentRelatedContent
  menuIsOpened = false
  searchIsOpened = false
  schema: object
  menuItemColumn
  buttonsHeader = []

  @ViewChild('multilevelMenuC') multilevelMenuC: MultilevelMenuComponent

  constructor(
    public localDeviceDetector: LocalDeviceDetectorService,
    public richsnipetService: RichsnipetService) {
  }

  ngOnInit(): void {
    this.module?.content?.row?.forEach(rowItem => {
      rowItem?.column.forEach(column => {
        column?.items_column?.forEach(itemColumn => {
          if (itemColumn?.identifier === 'menu') {
            this.menuItemColumn = itemColumn
          }
          if (itemColumn?.identifier === 'button') {
            this.buttonsHeader.push(itemColumn)
          }
        })
      })
    })
    this.schema = this.richsnipetService.setupJsonUniversity(this.universityInfo)
  }

  closeAndOpenMenu() {
    this.menuIsOpened ? this.menuIsOpened = false : this.menuIsOpened = true
    this.multilevelMenu = null
    this.closeMultilevelMenu()
  }

  closeAll() {
    this.searchIsOpened = false
    this.menuIsOpened = false
    this.currentRelatedContent = null
    this.multilevelMenu = null
    this.notSupportedEmitter.emit(null)
    this.closeMultilevelMenu()
    this.closeRelatedContentButtons()

    if (this.multilevelMenuC) {
      this.multilevelMenuC.closeSecondLevel(event)
      this.multilevelMenuC.closeThirdLevel(event)
      this.multilevelMenuC.selectedContent = []
      this.multilevelMenuC.fourthLevelMenu = []
      this.multilevelMenuC.thirdLevelMenu = []
      this.multilevelMenuC.fourthLevelMenuMode = null
    }
  }

  relatedContentUpdate(relatedContent) {
    this.multilevelMenu = null
    this.searchIsOpened = false
    this.menuIsOpened = false
    this.notSupportedEmitter.emit(null)

    if (this.currentRelatedContent) {
      if (this.currentRelatedContent?.id === relatedContent?.id && this.currentRelatedContent?.component === relatedContent?.component) {
        this.searchIsOpened = false
        this.currentRelatedContent = null
      } else {
        if (this.localDeviceDetector.isMobile() && relatedContent?.component === 'search') {
          this.searchIsOpened = true
        } else {
          this.searchIsOpened = false
        }
        this.currentRelatedContent = relatedContent
      }
    } else {
      if (this.localDeviceDetector.isMobile() && relatedContent?.component === 'search') {
        this.searchIsOpened = true
      } else {
        this.searchIsOpened = false
      }
      this.currentRelatedContent = relatedContent
    }
  }

  changeSecondLevel(event) {
    this.searchIsOpened = false
    this.notSupportedEmitter.emit(null)
    this.currentRelatedContent = null
    if (this.multilevelMenu !== event) {
      this.multilevelMenu = event
    }
    if (this.multilevelMenuC) {
      this.multilevelMenuC.closeSecondLevel(event)
      this.multilevelMenuC.closeThirdLevel(event)
      this.multilevelMenuC.fourthLevelMenu = []
      this.multilevelMenuC.thirdLevelMenu = []
      this.multilevelMenuC.fourthLevelMenuMode = null
    }
  }

  notSupportedEvent(notSupportedModule) {
    if (notSupportedModule) {
      this.notSupportedEmitter.emit(notSupportedModule)
    }
  }

  closeSearch() {
    this.multilevelMenu = null
    this.searchIsOpened = false
    this.menuIsOpened = false
    this.currentRelatedContent = null
    this.notSupportedEmitter.emit(null)
    this.closeMultilevelMenu()
    this.closeRelatedContentButtons()
  }

  closeRelatedContentButtons() {
    this.module?.content?.row[0]?.column.forEach(column => {
      column?.items_column?.forEach(itemColum => {
        itemColum.active = false
      })
    })
  }

  closeMultilevelMenu() {
    this.multilevelMenu = null
    this.principalMenu['main-menu']?.forEach(itemMenu => {
      itemMenu.data.active = false
    })
  }

  pageEmitter(event) {
    this.closeAll()
    this.page.emit(event)
  }

  anchorEmitter(event) {
    this.closeAll()
    this.anchorCustom.emit(event)
  }

  externalLinkEmitter() {
    this.closeAll()
  }

}
